import {
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  localizeKey,
  sentryDSNKey,
  OAUTH_PROVIDERS_COM,
  COOKIE_POLICY_URL,
  DATA_PROCESSING_AGREEMENT_URL,
  PRIVACY_POLICY_URL,
  TERMS_OF_SERVICE_URL,
} from "@src/runtime-config-base";
import { RuntimeConfig } from "@src/runtime-config-types";

export const runtimeConfig: RuntimeConfig = {
  environment: "production",
  appRegion: "com",
  appEnv: "com-production",
  urls: {
    apiBaseUrl: "https://core.api.holobuilder.com",
    projectApiUrl: "https://v2.project.api.holobuilder.com",
    viewerUrl: "https://viewer.holobuilder.com",
    webEditorUrl: "https://app.holobuilder.com/app",
    apiBaseComUrl: "https://core.api.holobuilder.com",
    apiBaseEuUrl: "https://core.api.holobuilder.eu",
    sphereDashboardUrl: "https://sphere.holobuilder.com",
    dashboard20ComUrl: "https://sphere.holobuilder.com",
    dashboard20EuUrl: "https://sphere.holobuilder.eu",
    sphereEntryPageComUrl: "https://entry.holobuilder.com",
    sphereEntryPageEuUrl: "https://entry.holobuilder.eu",
    sphereEntryPageApi: "https://entry.holobuilder.com/api",
    termsOfServiceUrl: TERMS_OF_SERVICE_URL,
    privacyPolicyUrl: PRIVACY_POLICY_URL,
    dataProcessingAgreementUrl: DATA_PROCESSING_AGREEMENT_URL,
    cookiePolicyUrl: COOKIE_POLICY_URL,
  },
  features: {
    localizeKey,
    sentryDSNKey,
  },
  oauth: {
    providers: OAUTH_PROVIDERS_COM,
  },
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  mailSupportAddress: "support@holobuilder.com",
  isNumberedEnv: false,
  numberedEnv: null,
};
